<ion-button
  expand="block"
  (click)="contact()"
  [color]="buttonColor"
  [fill]="buttonFill"
  size="default"
>
  <ion-label>
    {{ buttonText }}
  </ion-label>
</ion-button>
